import React from "react";
import "./Paragraph.scss";
import { ITextElement } from "../../../types/ITextElement";

export default function Paragraph({ id, className, children, onClick }: ITextElement) {
    return <p id={id} className={className} onClick={onClick}>{children}</p>;
}